var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    { attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48" } },
    [
      _c("path", {
        attrs: {
          fill: "currentColor",
          "fill-rule": "nonzero",
          d: "M3.398 23.906c0 8.118 4.718 15.134 11.559 18.458L5.174 15.56a20.431 20.431 0 0 0-1.776 8.346zm34.354-1.035c0-2.534-.91-4.29-1.691-5.656-1.04-1.69-2.014-3.12-2.014-4.81 0-1.884 1.43-3.64 3.444-3.64.09 0 .177.012.266.017a20.433 20.433 0 0 0-13.85-5.384c-7.165 0-13.468 3.676-17.135 9.244.48.015.934.025 1.32.025 2.144 0 5.465-.26 5.465-.26 1.106-.066 1.236 1.558.132 1.69 0 0-1.111.13-2.348.194l7.469 22.215 4.488-13.46-3.195-8.755a37.345 37.345 0 0 1-2.15-.196c-1.106-.064-.976-1.754.129-1.689 0 0 3.387.26 5.402.26 2.145 0 5.466-.26 5.466-.26 1.106-.065 1.236 1.559.131 1.69 0 0-1.113.13-2.347.195l7.411 22.046 2.046-6.836c.887-2.836 1.561-4.874 1.561-6.63zm-13.485 2.83l-6.153 17.88a20.506 20.506 0 0 0 12.604-.327 1.8 1.8 0 0 1-.146-.283l-6.305-17.27zm17.636-11.634c.088.653.138 1.354.138 2.109 0 2.08-.389 4.42-1.56 7.346l-6.264 18.112c6.097-3.556 10.198-10.161 10.198-17.727 0-3.566-.91-6.919-2.512-9.84zM23.907 0C10.725 0 0 10.724 0 23.906 0 37.09 10.725 47.814 23.907 47.814S47.815 37.09 47.815 23.906C47.815 10.724 37.09 0 23.907 0zm0 46.718c-12.577 0-22.81-10.233-22.81-22.812 0-12.577 10.232-22.81 22.81-22.81 12.577 0 22.81 10.233 22.81 22.81 0 12.579-10.233 22.812-22.81 22.812z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }